<template>
    <form @submit.prevent="handleContact">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Select or Create Contact</p>
            </header>
            <section class="modal-card-body">
                <o-field label="Role" :type="fieldType('role')" :message="getError('role')">
                    <o-input type="role" placeholder="Role" v-model="copy.role" tabindex="2" />
                </o-field>

                <o-tabs v-model="activeTab">
                    <o-tab-item :value="0" label="Choose">
                        <o-field label="Company" style="flex: 1">
                            <autocomplete-select type="company" v-model="company_id" />
                        </o-field>

                        <o-field label="Contact">
                            <o-select placeholder="Select a Contact" v-model="contact_id" expanded>
                                <option :value="null">Not Specified</option>
                                <option
                                    v-for="contact in contactsByCompanyId(company_id)"
                                    :value="contact.id"
                                    :key="contact.id">
                                    {{ contact.full_name }}
                                </option>
                            </o-select>
                        </o-field>
                    </o-tab-item>

                    <o-tab-item :value="1" label="Create">
                        <o-tabs v-model="internalActiveTab">
                            <o-tab-item :value="0" label="General">
                                <o-field label="Company" style="flex: 1">
                                    <autocomplete-select type="company" v-model="copy.company_id" :error="getError('company_id')" :tabindex="1" :allowcreate="true" v-on:create="handleCreateCompany" />
                                </o-field>

                                <o-field label="Email" :type="fieldType('email')" :message="getError('email')">
                                  <template #label>
                                    Email <span style="color: red">*</span>
                                  </template>
                                    <o-input type="email" placeholder="company@example.com" v-model="copy.email" tabindex="2" />
                                </o-field>
                                <div class="columns">
                                    <div class="column">
                                        <o-field label="First Name" :type="fieldType('first_name')" :message="getError('first_name')">
                                          <template #label>
                                            First Name <span style="color: red">*</span>
                                          </template>
                                            <o-input v-model="copy.first_name" tabindex="3" />
                                        </o-field>
                                        <o-field label="Telephone" :type="fieldType('telephone')" :message="getError('telephone')">
                                            <o-input v-model="copy.telephone" tabindex="5" />
                                        </o-field>

                                    </div>
                                    <div class="column">
                                        <o-field label="Last Name" :type="fieldType('last_name')" :message="getError('last_name')">
                                          <template #label>
                                            Last Name <span style="color: red">*</span>
                                          </template>
                                            <o-input v-model="copy.last_name" tabindex="4" />
                                        </o-field>

                                        <o-field label="Mobile" :type="fieldType('mobile')" :message="getError('mobile')">
                                            <o-input v-model="copy.mobile" tabindex="6" />
                                        </o-field>
                                    </div>
                                </div>

                                <o-field label="Fax" :type="fieldType('fax')" :message="getError('fax')">
                                    <o-input v-model="copy.fax" tabindex="7" />
                                </o-field>

                                <o-field label="Title" :type="fieldType('title')" :message="getError('title')">
                                    <o-input v-model="copy.title"  tabindex="8" />
                                </o-field>

                                <div class="field">
                                    <o-checkbox v-model="sameAddressAsCompany" :disabled="!copy.company_id">
                                        Same address as the company
                                    </o-checkbox>
                                </div>

                                <div class="columns">
                                    <div class="column">
                                        <o-field label="Address 1" :type="fieldType('address_1')" :message="getError('address_1')">
                                            <o-input v-model="copy.address_1" tabindex="9" />
                                        </o-field>

                                        <o-field label="City" :type="fieldType('city')" :message="getError('city')">
                                            <o-input v-model="copy.city"  tabindex="11" />
                                        </o-field>
                                    </div>
                                    <div class="column">
                                        <o-field label="Address 2" :type="fieldType('address_2')" :message="getError('address_2')">
                                            <o-input v-model="copy.address_2" tabindex="10" />
                                        </o-field>

                                        <o-field label="State" :type="fieldType('state')" :message="getError('state')">
                                            <autocomplete-select type="state" v-model="copy.state" :tabindex="12" />
                                        </o-field>
                                    </div>
                                </div>

                                <o-field label="Zip" :type="fieldType('zip')" :message="getError('zip')">
                                    <o-input v-model="copy.zip" tabindex="13" />
                                </o-field>
                            </o-tab-item>
                            <o-tab-item :value="1" label="License Number" class="licenses">
                                <template v-if="copy.licenses">
                                    <o-field label="TAX ID">
                                        <o-input placeholder="Tax ID" v-model="copy.tax_id" tabindex="3" />
                                    </o-field>
                                    <hr>
                                    <o-field label="PE">
                                        <o-input placeholder="License #" v-model="copy.licenses.PE.value" tabindex="3" />
                                    </o-field>
                                    <datepicker v-model="copy.licenses.PE.exp_date"
                                                input-class="input is-fullwidth"
                                                placeholder="Exp. Date" :absolute="false"
                                    />

                                    <o-field label="SIA">
                                        <o-input placeholder="License #" v-model="copy.licenses.SIA.value" tabindex="3" />
                                    </o-field>
                                    <datepicker v-model="copy.licenses.SIA.exp_date"
                                                input-class="input is-fullwidth"
                                                placeholder="Exp. Date" :absolute="false"
                                    />

                                    <o-field label="FSC">
                                        <o-input placeholder="License #" v-model="copy.licenses.FSC.value" tabindex="3" />
                                    </o-field>
                                    <datepicker v-model="copy.licenses.FSC.exp_date"
                                                input-class="input is-fullwidth"
                                                placeholder="Exp. Date" :absolute="false"
                                    />

                                    <o-field label="SH">
                                        <o-input placeholder="License #" v-model="copy.licenses.SH.value" tabindex="3" />
                                    </o-field>
                                    <datepicker v-model="copy.licenses.SH.exp_date"
                                                input-class="input is-fullwidth"
                                                placeholder="Exp. Date" :absolute="false"
                                    />

                                    <o-field label="SOC">
                                        <o-input placeholder="License #" v-model="copy.licenses.SOC.value" tabindex="3" />
                                    </o-field>
                                    <datepicker v-model="copy.licenses.SOC.exp_date"
                                                input-class="input is-fullwidth"
                                                placeholder="Exp. Date" :absolute="false"
                                    />

                                    <o-field label="RA">
                                        <o-input placeholder="License #" v-model="copy.licenses.RA.value" tabindex="3" />
                                    </o-field>
                                    <datepicker v-model="copy.licenses.RA.exp_date"
                                                input-class="input is-fullwidth"
                                                placeholder="Exp. Date" :absolute="false"
                                    />

                                    <o-field label="MP">
                                        <o-input placeholder="License #" v-model="copy.licenses.MP.value" tabindex="3" />
                                    </o-field>
                                    <datepicker v-model="copy.licenses.MP.exp_date"
                                                input-class="input is-fullwidth"
                                                placeholder="Exp. Date" :absolute="false"
                                    />

                                    <o-field label="GC">
                                        <o-input placeholder="License #" v-model="copy.licenses.GC.value" tabindex="3" />
                                    </o-field>
                                    <datepicker v-model="copy.licenses.GC.exp_date"
                                                input-class="input is-fullwidth"
                                                placeholder="Exp. Date" :absolute="false"
                                    />

                                    <o-field label="SSM" :type="fieldType('SSM')" :message="getError('SSM')">
                                        <o-input placeholder="License #" v-model="copy.licenses.SSM.value" tabindex="3" />
                                    </o-field>
                                    <datepicker v-model="copy.licenses.SSM.exp_date"
                                                input-class="input is-fullwidth"
                                                placeholder="Exp. Date" :absolute="false"
                                    />
                                </template>
                            </o-tab-item>
                            <o-tab-item :value="2" label="Credentials">

                            </o-tab-item>
                        </o-tabs >
                    </o-tab-item>
                </o-tabs >
            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click.prevent="$parent.$parent.$emit('update:active', false)">Close</button>
                <button type="submit" class="button is-primary"><o-icon icon="save"/><span>Add</span></button>
            </footer>
        </div>
    </form>
</template>


<script>
import Datepicker from '../../components/Datepicker'
import { mapActions, mapGetters } from 'vuex'
import HandlesForm from './../../mixins/HandlesForm'
import CompanyModal from './Company'

export default {
  mixins: [HandlesForm],

  components: {
    Datepicker
  },

  computed: {
    ...mapGetters(['contacts', 'companies', 'contactsByCompanyId', 'contactById', 'contactLicenses', 'companyById']),
    sameAddressAsCompany: {
      get() {
        return this.company && this.copy.address_1 == this.company.address
      },
      set(value) {
        this.copy.address_1 = value ? this.company.address : ''
      }
    },
    company() {
      return this.companyById(this.copy.company_id)
    }
  },

  data() {
    return {
      activeTab: 0,
      internalActiveTab: 0,
      company_id: null,
      contact_id: null,

      copy: {
        first_name: '',
        last_name: '',
        telephone: '',
        mobile: '',
        email: '',
        fax: '',
        title: '',
        address_1: '',
        address_2: '',
        licenses: null,
        city: '',
        state: '',
        zip: '',
        company_id: this.$route.params.slug,
        role: null
      }
    }
  },

  mounted() {
    this.copy.licenses = this.copy.licenses || _.cloneDeep(this.contactLicenses)
  },

  watch:{
    'company_id'(value){
      this.fetchContacts({company_id: value})
    }
  },

  methods: {
    ...mapActions(['fetchContacts', 'fetchCompanies', 'createOrUpdateContact']),

    handleContact () {
      if (this.activeTab === 1) {
        let submit = this.wrapSubmit(this.createOrUpdateContact)

        submit(this.copy)
            .then(res => {
              this.successMessage('Contact has been successfull added')
              this.$parent.$parent.$emit('update:active', false)

              this.$emit('select', res.data.data, this.copy.role)

                  this.activeTab = 0
                  this.internalActiveTab = 0
                  this.company_id = null
                  this.contact_id = null
                  this.copy = {
                    first_name: '',
                    last_name: '',
                    telephone: '',
                    mobile: '',
                    email: '',
                    fax: '',
                    title: '',
                    address_1: '',
                    address_2: '',
                    licenses: null,
                    city: '',
                    state: '',
                    zip: '',
                    company_id: this.$route.params.slug,
                    role: null
                  }
              return res
            }).catch(() => this.internalActiveTab = 0)
      } else if (this.contact_id) {
        this.$emit('select', this.contactById(this.contact_id), this.copy.role)
      }

    },

    fetchCompanyContacts() {
      this.contact_id = null

      if (this.copy.company_id) {
        this.fetchContacts({company_id: this.company_id})
      }
    },
    handleCreateCompany(name) {
      this.openModalComponent(CompanyModal, {item : { name }})
          .then(id => this.copy.company_id = id)
    }
  },
}
</script>
